import type {PacketPhoto} from "./PacketPhoto";

/**
 * Dane wyświetlanej oferty w standardzie
 */
export class OfferModel {
    declare id: number;
    declare name: string;
    declare packetId?: string;
    declare translated_name: string;
    declare translated_description: string;
    declare translated_extended_description: string;
    declare order: number | null;
    declare meals: number[];
    declare rules: {
        cancellation_rule_name: string,
        cancellation_rule: string,
        prepayment_rule: string
    };
    declare reservation_terms_configuration_id: number;
    declare photos: PacketPhoto[];
    declare is_available: boolean;
    /**
     * 0 - wyświetlamy tą ofertę jedynie na liście stanadrdów
     * 1 - wyświetlamy tą ofertę na liście pakietów
     * 2 - wyświetlamy tą ofertę na liście ofert
     */
    declare expose_in_offer_bundles: number;

}
